
import { useState } from 'react';

export default function HomePage() {
  const [activeTab, setActiveTab] = useState('profile');

  const personalHonors = [
    '大运河公益大使',
    '全网首位粉丝破亿女主播',
    '全网粉丝量最多的女主播',
    '全网销售金额最高的女主播',
    '天猫宝藏新品牌萌新孵化官',
    '快手高光主播、年度百大主播',
    '吉林、西安、四川好物推荐官',
    '阿里妈妈淘宝联盟最佳带货明星',
    '四川省网商创新发展促进会副秘书长',
    '吉林省民营企业和中小企业协会副会长',
    '长春师范大学文旅与电影学院客座教授'
  ];

  const publicWelfareEvents = [
    {
      date: '2024年09月',
      event: '作为"吉林省民营企业和中小企业协会副会长"，发起"吉品出山·心归故乡"助农直播公益专场'
    },
    {
      date: '2024年09月',
      event: '作为长春师范大学文旅与电影学院客座教授，为母校长春师范大学捐赠100万，设立"润心奖学金"'
    },
    {
      date: '2023年07月',
      event: '作为"四川省网商创新发展促进会副秘书长"为"乡村振兴公益计划·四川站"好物出川推出公益专场直播'
    },
    {
      date: '2022年07月',
      event: '受西安市邀请参加"直播惠民生·醉美长安城"直播带货节，公益助农，让陕西特产破圈走入千家万户'
    },
    {
      date: '2022年01月',
      event: '发起"中国青年年货书"公益专场直播，为年货农产品站台，服务乡村振兴，让网红农产品走进千家万户'
    },
    {
      date: '2021年11月',
      event: '参加"千年大运河·文脉颂中华"天津站公益直播，为疫情下的大运河流域经济发展注入"心"支持'
    },
    {
      date: '2021年07月',
      event: '受央视财经"燃动之夜"邀请，携手撒贝宁、朱广权及游泳世界冠军傅园慧，为奥运健儿加油'
    },
    {
      date: '2021年07月',
      event: '发起"国货之光"直播带货专场，为来自河南灾区捐款捐物的企业带货，为捐赠企业灾后恢复提供支持'
    },
    {
      date: '2021年10月',
      event: '受中央广播电视总台邀请参与"宝藏国货"直播活动，与主持人撒贝宁尼格买提一起助力国货崛起'
    },
    {
      date: '2020年10月',
      event: '参与第八届网络视听大会与知名主持人演员刘仪伟一起助力脱贫攻坚，复工复产'
    },
    {
      date: '2020年04月',
      event: '受央视新闻、快手邀请参与"湖北公益直播活动"，助力疫情后的湖北复工复产'
    }
  ];

  const achievements = [
    {
      title: '全网粉丝破亿',
      description: '成为全网首位粉丝破亿的直播带货女主播',
      icon: 'ri-user-star-line'
    },
    {
      title: '快手带货榜首',
      description: '2023年快手全年带货榜榜首',
      icon: 'ri-trophy-line'
    },
    {
      title: '知名主播',
      description: '快手超头部主播，直播带货领域领军人物',
      icon: 'ri-building-line'
    },
    {
      title: '公益大使',
      description: '大运河公益大使，积极参与各类公益活动',
      icon: 'ri-heart-line'
    }
  ];

  const works = [
    {
      title: '直播带货',
      description: '专业的直播带货，为粉丝推荐优质产品',
      image: 'https://static.readdy.ai/image/f07c49612aa26b21f7c4157143a2b686/be15212267d04d5613921e4b65fbd5fc.png'
    },
    {
      title: '公益活动',
      description: '积极参与各类公益活动，回馈社会',
      image: 'https://static.readdy.ai/image/f07c49612aa26b21f7c4157143a2b686/b0c879e9bd4c38e6b5c33bdad3ecc5b5.jpeg'
    },
    {
      title: '品牌合作',
      description: '与各大品牌深度合作，推广优质产品',
      image: 'https://static.readdy.ai/image/f07c49612aa26b21f7c4157143a2b686/4007d0b265a12c2335cf6e6e7eec4c54.jpeg'
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-pink-50 via-purple-50 to-indigo-50">
      {/* Header */}
      <header className="fixed top-0 w-full bg-white/90 backdrop-blur-md shadow-sm z-50">
        <div className="max-w-6xl mx-auto px-4 lg:px-8 py-3">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-3">
              <div className="w-10 h-10 lg:w-12 lg:h-12 rounded-full overflow-hidden flex items-center justify-center">
                <img 
                  src="https://we3.vip/zb_users/upload/2025/10/wishing-egg-logo.png"
                  alt="蛋蛋logo"
                  className="w-full h-full object-cover"
                />
              </div>
              <div>
                <h1 className="text-lg lg:text-xl font-bold text-gray-800" style={{ fontFamily: '"Pacifico", serif' }}>蛋蛋</h1>
                <p className="text-xs lg:text-sm text-gray-500">杨润心粉丝应援官网</p>
              </div>
            </div>
            <button className="w-8 h-8 lg:w-10 lg:h-10 flex items-center justify-center lg:hidden">
              <i className="ri-menu-line text-gray-600 text-xl"></i>
            </button>
            {/* Desktop Navigation */}
            <nav className="hidden lg:flex space-x-8">
              <button 
                onClick={() => setActiveTab('profile')}
                className={`px-4 py-2 rounded-full text-sm font-medium transition-all ${
                  activeTab === 'profile'
                    ? 'bg-gradient-to-r from-pink-500 to-purple-500 text-white'
                    : 'text-gray-600 hover:text-gray-800'
                }`}
              >
                个人资料
              </button>
              <button 
                onClick={() => setActiveTab('honors')}
                className={`px-4 py-2 rounded-full text-sm font-medium transition-all ${
                  activeTab === 'honors'
                    ? 'bg-gradient-to-r from-pink-500 to-purple-500 text-white'
                    : 'text-gray-600 hover:text-gray-800'
                }`}
              >
                荣誉成就
              </button>
              <button 
                onClick={() => setActiveTab('welfare')}
                className={`px-4 py-2 rounded-full text-sm font-medium transition-all ${
                  activeTab === 'welfare'
                    ? 'bg-gradient-to-r from-pink-500 to-purple-500 text-white'
                    : 'text-gray-600 hover:text-gray-800'
                }`}
              >
                公益足迹
              </button>
            </nav>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="pt-20 lg:pt-24 pb-24 lg:pb-8">
        <div className="max-w-6xl mx-auto">
          {/* Hero Section */}
          <section className="px-4 lg:px-8 py-8 lg:py-12">
            <div className="text-center mb-8 lg:mb-12">
              <div className="w-24 h-24 lg:w-32 lg:h-32 mx-auto mb-4 lg:mb-6 rounded-full overflow-hidden bg-gradient-to-r from-pink-400 to-purple-500 p-1">
                <div className="w-full h-full rounded-full overflow-hidden">
                  <img 
                    src="https://static.readdy.ai/image/f07c49612aa26b21f7c4157143a2b686/26fe89aa8b67433a4cbfbc676cf4ab6f.png"
                    alt="蛋蛋"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
              <h2 className="text-2xl lg:text-4xl font-bold text-gray-800 mb-2 lg:mb-4">蛋蛋 · 杨润心</h2>
              <p className="text-gray-600 mb-4 lg:mb-8 text-base lg:text-lg">全网首位粉丝破亿女主播</p>
              <div className="flex justify-center space-x-6 lg:space-x-12">
                <div className="text-center">
                  <div className="text-xl lg:text-3xl font-bold text-pink-500">1亿+</div>
                  <div className="text-xs lg:text-sm text-gray-500">全网粉丝</div>
                </div>
                <div className="text-center">
                  <div className="text-xl lg:text-3xl font-bold text-purple-500">榜首</div>
                  <div className="text-xs lg:text-sm text-gray-500">带货排行</div>
                </div>
                <div className="text-center">
                  <div className="text-xl lg:text-3xl font-bold text-indigo-500">公益</div>
                  <div className="text-xs lg:text-sm text-gray-500">大使身份</div>
                </div>
              </div>
            </div>
          </section>

          {/* Mobile Tab Navigation */}
          <section className="px-4 mb-6 lg:hidden">
            <div className="flex bg-white rounded-full p-1 shadow-sm">
              <button
                onClick={() => setActiveTab('profile')}
                className={`flex-1 py-2 px-4 rounded-full text-sm font-medium transition-all ${
                  activeTab === 'profile'
                    ? 'bg-gradient-to-r from-pink-500 to-purple-500 text-white'
                    : 'text-gray-600'
                }`}
              >
                个人资料
              </button>
              <button
                onClick={() => setActiveTab('honors')}
                className={`flex-1 py-2 px-4 rounded-full text-sm font-medium transition-all ${
                  activeTab === 'honors'
                    ? 'bg-gradient-to-r from-pink-500 to-purple-500 text-white'
                    : 'text-gray-600'
                }`}
              >
                荣誉成就
              </button>
              <button
                onClick={() => setActiveTab('welfare')}
                className={`flex-1 py-2 px-4 rounded-full text-sm font-medium transition-all ${
                  activeTab === 'welfare'
                    ? 'bg-gradient-to-r from-pink-500 to-purple-500 text-white'
                    : 'text-gray-600'
                }`}
              >
                公益足迹
              </button>
            </div>
          </section>

          {/* Tab Content */}
          <section className="px-4 lg:px-8">
            <div className="lg:grid lg:grid-cols-12 lg:gap-8">
              {/* Main Content Area */}
              <div className="lg:col-span-8">
                {activeTab === 'profile' && (
                  <div className="space-y-6 lg:space-y-8">
                    <div className="bg-white rounded-2xl p-6 lg:p-8 shadow-sm">
                      <h3 className="text-lg lg:text-xl font-bold text-gray-800 mb-4 lg:mb-6">基本信息</h3>
                      <div className="space-y-3 lg:space-y-4">
                        <div className="flex justify-between">
                          <span className="text-gray-600 lg:text-base">真实姓名</span>
                          <span className="font-medium lg:text-base">杨润心</span>
                        </div>
                        <div className="flex justify-between">
                          <span className="text-gray-600 lg:text-base">网络昵称</span>
                          <span className="font-medium lg:text-base">蛋蛋</span>
                        </div>
                        <div className="flex justify-between">
                          <span className="text-gray-600 lg:text-base">主要平台</span>
                          <span className="font-medium lg:text-base">快手</span>
                        </div>
                        <div className="flex justify-between">
                          <span className="text-gray-600 lg:text-base">职业身份</span>
                          <span className="font-medium lg:text-base">直播带货主播</span>
                        </div>
                        <div className="flex justify-between">
                          <span className="text-gray-600 lg:text-base">主要成就</span>
                          <span className="font-medium lg:text-base">全网首位粉丝破亿女主播</span>
                        </div>
                      </div>
                    </div>

                    <div className="bg-white rounded-2xl p-6 lg:p-8 shadow-sm">
                      <h3 className="text-lg lg:text-xl font-bold text-gray-800 mb-4 lg:mb-6">主要成就</h3>
                      <div className="grid grid-cols-2 lg:grid-cols-2 gap-4 lg:gap-6">
                        {achievements.map((achievement, index) => (
                          <div key={index} className="text-center p-4 lg:p-6 bg-gradient-to-br from-pink-50 to-purple-50 rounded-xl">
                            <div className="w-12 h-12 lg:w-16 lg:h-16 mx-auto mb-2 lg:mb-4 bg-white rounded-full flex items-center justify-center shadow-sm">
                              <i className={`${achievement.icon} text-pink-500 text-xl lg:text-2xl`}></i>
                            </div>
                            <h4 className="font-medium text-gray-800 text-sm lg:text-base mb-1 lg:mb-2">{achievement.title}</h4>
                            <p className="text-xs lg:text-sm text-gray-600 leading-relaxed">{achievement.description}</p>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                )}

                {activeTab === 'honors' && (
                  <div className="bg-white rounded-2xl p-6 lg:p-8 shadow-sm">
                    <h3 className="text-lg lg:text-xl font-bold text-gray-800 mb-4 lg:mb-6">个人荣誉</h3>
                    <div className="space-y-3 lg:space-y-4">
                      {personalHonors.map((honor, index) => (
                        <div key={index} className="flex items-center space-x-3 lg:space-x-4 p-3 lg:p-4 bg-gradient-to-r from-pink-50 to-purple-50 rounded-xl">
                          <div className="w-8 h-8 lg:w-10 lg:h-10 bg-gradient-to-r from-pink-500 to-purple-500 rounded-full flex items-center justify-center flex-shrink-0">
                            <i className="ri-award-line text-white text-sm lg:text-base"></i>
                          </div>
                          <span className="text-gray-700 text-sm lg:text-base">{honor}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {activeTab === 'welfare' && (
                  <div className="bg-white rounded-2xl p-6 lg:p-8 shadow-sm">
                    <h3 className="text-lg lg:text-xl font-bold text-gray-800 mb-4 lg:mb-6">公益足迹</h3>
                    <div className="space-y-4 lg:space-y-6">
                      {publicWelfareEvents.map((event, index) => (
                        <div key={index} className="border-l-4 border-pink-300 pl-4 lg:pl-6 py-2 lg:py-3">
                          <div className="text-sm lg:text-base font-medium text-pink-600 mb-1 lg:mb-2">{event.date}</div>
                          <p className="text-sm lg:text-base text-gray-700 leading-relaxed">{event.event}</p>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>

              {/* Sidebar for Desktop */}
              <div className="lg:col-span-4 mt-8 lg:mt-0">
                {/* Works Section */}
                <section className="mb-3 lg:mb-0">
                  <h3 className="text-lg lg:text-xl font-bold text-gray-800 mb-4 lg:mb-6">活动剪影</h3>
                  <div className="space-y-4 lg:space-y-6" data-product-shop>
                    {works.map((work, index) => (
                      <div key={index} className="bg-white rounded-2xl overflow-hidden shadow-sm">
                        <div className="h-48 lg:h-40 overflow-hidden">
                          <img 
                            src={work.image}
                            alt={work.title}
                            className="w-full h-full object-cover object-top"
                          />
                        </div>
                        <div className="p-4 lg:p-4">
                          <h4 className="font-medium text-gray-800 mb-2 text-sm lg:text-base">{work.title}</h4>
                          <p className="text-sm lg:text-sm text-gray-600">{work.description}</p>
                        </div>
                      </div>
                    ))}
                  </div>
                </section>
              </div>
            </div>
          </section>
        </div>
      </main>

      {/* Desktop Footer */}
      <footer className="hidden lg:block bg-gradient-to-br from-gray-50 to-gray-100 py-12 px-8 border-t border-gray-200">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 text-center lg:text-left">
            {/* 版权信息 */}
            <div className="space-y-4">
              <div className="flex items-center justify-center lg:justify-start space-x-2 text-gray-700">
                <i className="ri-copyright-line text-pink-500"></i>
                <span className="text-base font-medium">2019 - 2025 蛋蛋粉丝团</span>
              </div>
              <p className="text-sm text-gray-500 leading-relaxed">
                版权所有 · 保留所有权利
              </p>
              <p className="text-sm text-gray-400 leading-relaxed">
                本站为蛋蛋（杨润心）官方粉丝应援网站
              </p>
            </div>

            {/* 社交媒体链接 */}
            <div className="flex justify-center lg:justify-center space-x-6">
              <a 
                href="mailto:hayeen@qq.com"
                className="w-12 h-12 bg-gradient-to-r from-green-400 to-green-500 rounded-full flex items-center justify-center shadow-sm hover:shadow-md transition-all duration-300 hover:scale-110"
              >
                <i className="ri-mail-line text-white text-lg"></i>
              </a>
              <a 
                href="https://weibo.com/u/1899311027"
                target="_blank"
                rel="noopener noreferrer"
                className="w-12 h-12 bg-gradient-to-r from-pink-400 to-pink-500 rounded-full flex items-center justify-center shadow-sm hover:shadow-md transition-all duration-300 hover:scale-110"
              >
                <i className="ri-wechat-fill text-white text-lg"></i>
              </a>
              <a 
                href="https://xhslink.com/m/928kPzUwrFe"
                target="_blank"
                rel="noopener noreferrer"
                className="w-12 h-12 bg-gradient-to-r from-red-400 to-red-500 rounded-full flex items-center justify-center shadow-sm hover:shadow-md transition-all duration-300 hover:scale-110"
              >
                <i className="ri-heart-fill text-white text-lg"></i>
              </a>
              <a 
                href="https://weibo.com/u/1899311027"
                target="_blank"
                rel="noopener noreferrer"
                className="w-12 h-12 bg-gradient-to-r from-purple-400 to-purple-500 rounded-full flex items-center justify-center shadow-sm hover:shadow-md transition-all duration-300 hover:scale-110"
              >
                <i className="ri-star-fill text-white text-lg"></i>
              </a>
            </div>

            {/* 备案信息 */}
            <div className="flex flex-col space-y-2 text-sm text-gray-500 justify-center lg:justify-end items-center lg:items-end">
              <div className="flex flex-col lg:flex-row lg:items-center lg:space-x-4 space-y-1 lg:space-y-0">
                <a 
                  href="https://beian.miit.gov.cn/"
                  className="hover:text-gray-700 transition-colors"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  浙ICP备16008979号-3
                </a>
                <a 
                  href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33011002011347"
                  className="hover:text-gray-700 transition-colors"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  浙公网安备33011002011347号
                </a>
              </div>
            </div>
          </div>
        </div>
      </footer>

      {/* Mobile Footer */}
      <footer className="lg:hidden bg-gradient-to-br from-gray-50 to-gray-100 py-6 px-4 text-center border-t border-gray-200 mb-16">
        <div className="max-w-sm mx-auto space-y-4">
          {/* 版权信息 */}
          <div className="space-y-2">
            <div className="flex items-center justify-center space-x-2 text-gray-700">
              <i className="ri-copyright-line text-pink-500"></i>
              <span className="text-sm font-medium">2019 - 2025 蛋蛋粉丝团</span>
            </div>
            <p className="text-xs text-gray-500 leading-relaxed">
              版权所有 · 保留所有权利
            </p>
            <p className="text-xs text-gray-400 leading-relaxed">
              本站为蛋蛋（杨润心）官方粉丝应援网站
            </p>
          </div>

          {/* 社交媒体链接和联系邮箱 */}
          <div className="flex justify-center space-x-4 pt-2">
            <a 
              href="mailto:hayeen@qq.com"
              className="w-8 h-8 bg-gradient-to-r from-green-400 to-green-500 rounded-full flex items-center justify-center shadow-sm hover:shadow-md transition-all duration-300 hover:scale-110"
            >
              <i className="ri-mail-line text-white text-sm"></i>
            </a>
            <a 
              href="https://weibo.com/u/1899311027"
              target="_blank"
              rel="noopener noreferrer"
              className="w-8 h-8 bg-gradient-to-r from-pink-400 to-pink-500 rounded-full flex items-center justify-center shadow-sm hover:shadow-md transition-all duration-300 hover:scale-110"
            >
              <i className="ri-wechat-fill text-white text-sm"></i>
            </a>
            <a 
              href="https://xhslink.com/m/928kPzUwrFe"
              target="_blank"
              rel="noopener noreferrer"
              className="w-8 h-8 bg-gradient-to-r from-red-400 to-red-500 rounded-full flex items-center justify-center shadow-sm hover:shadow-md transition-all duration-300 hover:scale-110"
            >
              <i className="ri-heart-fill text-white text-sm"></i>
            </a>
            <a 
              href="https://weibo.com/u/1899311027"
              target="_blank"
              rel="noopener noreferrer"
              className="w-8 h-8 bg-gradient-to-r from-purple-400 to-purple-500 rounded-full flex items-center justify-center shadow-sm hover:shadow-md transition-all duration-300 hover:scale-110"
            >
              <i className="ri-star-fill text-white text-sm"></i>
            </a>
          </div>

          {/* 分割线 */}
          <div className="flex items-center justify-center space-x-4 py-2">
            <div className="h-px bg-gradient-to-r from-transparent via-gray-300 to-transparent flex-1"></div>
            <div className="w-2 h-2 bg-gradient-to-r from-pink-400 to-purple-400 rounded-full"></div>
            <div className="h-px bg-gradient-to-r from-transparent via-gray-300 to-transparent flex-1"></div>
          </div>

          {/* 备案信息并排 */}
          <div className="flex flex-col space-y-1 text-xs text-gray-500">
            <div className="flex items-center justify-center space-x-2">
              <a 
                href="https://beian.miit.gov.cn/"
                className="hover:text-gray-700 transition-colors text-xs"
                target="_blank"
                rel="noopener noreferrer"
              >
                <span className="text-xs">浙ICP备16008979号-3</span>
              </a>
              <span className="text-gray-300">|</span>
              <a 
                href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33011002011347"
                className="hover:text-gray-700 transition-colors text-xs"
                target="_blank"
                rel="noopener noreferrer"
              >
                <span className="text-xs">浙公网安备33011002011347号</span>
              </a>
            </div>
          </div>
        </div>
      </footer>

      {/* Mobile Bottom Navigation */}
      <nav className="lg:hidden fixed bottom-0 w-full bg-white border-t border-gray-100 z-50">
        <div className="grid grid-cols-4 h-16">
          <button className="flex flex-col items-center justify-center space-y-1">
            <i className="ri-home-5-fill text-pink-500 text-lg"></i>
            <span className="text-xs text-pink-500 font-medium">首页</span>
          </button>
          <button className="flex flex-col items-center justify-center space-y-1">
            <i className="ri-news-line text-gray-400 text-lg"></i>
            <span className="text-xs text-gray-400">动态</span>
          </button>
          <button className="flex flex-col items-center justify-center space-y-1">
            <i className="ri-heart-line text-gray-400 text-lg"></i>
            <span className="text-xs text-gray-400">应援</span>
          </button>
          <button className="flex flex-col items-center justify-center space-y-1">
            <i className="ri-user-line text-gray-400 text-lg"></i>
            <span className="text-xs text-gray-400">我的</span>
          </button>
        </div>
      </nav>
    </div>
  );
}
